// Konfigurace webpack
// @ts-ignore
if (!__DEV__) {
  // @ts-ignore
  __webpack_public_path__ = `${serverContextPath}/qsign/`;
}
